import { Component, ElementRef, EventEmitter, input, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { StudentListComponent } from '../../../../pages/personnel/student/student-list/student-list.component';
import { StudentApiServiceService } from '../../../../pages/personnel/student/student-api-service.service';
import { debounceTime, distinctUntilChanged, finalize, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from "../../../../providers/loader.component";
import { RouterModule } from '@angular/router';
import { CommonApiDataServiceService } from '../../../../pages/services/common-api-data-service.service';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { PreventEscCloseDirective } from '../../../../utils/prevent-esc-close.directive';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CascadingSelectServiceService } from '../../../../pages/services/cascading-select-service.service';
import { PaginationComponent } from "../../../pagination/pagination.component";

@Component({
  selector: 'app-selectable-student-list-modal',
  standalone: true,
  imports: [CommonModule, LoaderComponent, RouterModule,PreventEscCloseDirective, ReactiveFormsModule, PaginationComponent],
  templateUrl: './selectable-student-list-modal.component.html',
  styleUrl: './selectable-student-list-modal.component.css'
})
export class SelectableStudentListModalComponent {
  @ViewChild('modal') modal!: ElementRef<HTMLDialogElement>;
  @Input() categoryData: any = '';
  @Input() type: any = '';
  @Input() isOpen: boolean = false;
  @Output() closeModalemmit = new EventEmitter();
  selectedStudents: any[] = [];
  studentList: any[] = [];
  groupStudentsList: any[] = [];
  studentApiResList: any[] = [];
  isFetching: boolean = false;
  isSelectedView: boolean = false
  isreqSending: boolean = false
  filterForm!: FormGroup;
  isFilterApplied: boolean = false;
  paginationData: any = {};
  currentPage: number | null = null;
  isviewgroupstudents: boolean = false;

  departments: any[] = [];
  classes: any[] = [];
  batches: any[] = [];
  academicYears: any[] = [];
  constructor(
    private studentApiService: StudentApiServiceService,
    private commonApiService: CommonApiDataServiceService,
    private toasterService: ToasterService,
    private cascadedService: CascadingSelectServiceService,
    private fb: FormBuilder
  ) {
  }
  ngOnInit(): void {
    this.filterForm = this.fb.group({
      search: [''],
      department: [null],
      class: [{ value: null, disabled: true }],
      batch: [{ value: null, disabled: true }],
      status: [null],
      academic_year: [null]
    });

    this.filterForm.get('search')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      if (this.isSelectedView) {
        return;
      }
      this.currentPage = null;
      // this.getstudentsingroup()
      this.getStudents(this.filterForm.value);
      this.isFilterApplied = true;
    });

    this.cascadedService.academicEntries$.pipe(take(1)).subscribe((res: any) => {
      this.departments = res?.data ?? [];
    });
    this.cascadedService.academicYear$.pipe(take(1)).subscribe((res: any) => {
      this.academicYears = res?.data ?? [];
    });
  }

  getStudents(params?: any) {
    this.isFetching = true
    this.studentApiService.getStudentList(this.currentPage ?? undefined, params).pipe(finalize(() => { this.isFetching = false; })).subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          // Filter out students that already exist in groupStudentsList
          this.studentList = res?.data.filter((s: any) => 
            !this.groupStudentsList.some((g: any) => 
              g.id === s.master_student_profile_id || 
              g.id === s.id || 
              g.master_student_profile_id === s.master_student_profile_id
            )
          ) ?? [];
          this.studentApiResList = res?.data ?? [];
          this.paginationData = this.normalizePagination(res?.pagination);
          if (this.isSelectedView) {
            this.studentList = [...this.selectedStudents];
          }
        }
      },
      error: (err) => {
        console.error('HTTP error:', err);
      }
    })
  }

  isgroupstudnetclciked(e: Event) {
    const target = e.target as HTMLButtonElement;
    this.isviewgroupstudents = !this.isviewgroupstudents
    if (this.isviewgroupstudents) {
      this.getstudentsingroup();
    }
  }

  getstudentsingroup(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.isFetching = true  
      this.studentApiService.getStudentbyGroup(this.categoryData.id ?? undefined).pipe(finalize(() => { this.isFetching = false; })).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.groupStudentsList = res?.data?.students ?? [];
          }
          resolve();
        },
        error: (err) => {
          console.error('HTTP error:', err);
          reject(err);
        }
      })
    });
  }

  private normalizePagination(pagination: any): any {
    const safe = pagination ?? {};
    const currentPage = Number(safe.current_page ?? 0);
    const perPage = Number(safe.per_page ?? 0);
    const total = Number(safe.total ?? 0);
    if (!safe.last_page && perPage > 0 && total > 0) {
      safe.last_page = Math.ceil(total / perPage);
    }
    if (safe.prev_page === undefined && currentPage > 1) {
      safe.prev_page = currentPage - 1;
    }
    if (safe.next_page === undefined && safe.last_page && currentPage < safe.last_page) {
      safe.next_page = currentPage + 1;
    }
    if (!Array.isArray(safe.pages) || safe.pages.length === 0) {
      const lastPage = Number(safe.last_page ?? 0);
      safe.pages = lastPage > 0 ? Array.from({ length: lastPage }, (_, i) => i + 1) : [];
    }
    return safe;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && changes['isOpen'].currentValue) {
      console.log(this.type);

      if (this.categoryData) {
        console.log(this.categoryData);
        
        // Load group students first, then get filtered student list
        this.getstudentsingroup().then(() => {
          this.getStudents(this.filterForm?.value);
        });
      }
      setTimeout(() => {
        this.modal?.nativeElement?.showModal();
      });
    }
  }

  get isDataReady(): boolean {
    return !this.isFetching;
  }

  isStudentSelected(id: number): boolean {
    return this.selectedStudents.some(s => s.id === id);
  }

  selectAllStudents(e: Event) {
    const isChecked = (e.target as HTMLInputElement).checked;
    // Select only from filtered studentList, not from all API results
    isChecked ? this.selectedStudents = [...this.studentList] : this.selectedStudents = [];
  }

  selectStudent(e: Event, student: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedStudents.push(student);
    } else {
      this.selectedStudents = this.selectedStudents.filter((item) => item.id !== student.id);
    }
  }

  setTableView() {
    this.isSelectedView = !this.isSelectedView
    this.applyFilters();
  }

  closeModal(action: string) {
    if (action == 'save') {
      this.saveData();
      return
    }
    this.modal?.nativeElement?.close();
    this.isOpen = false;
    this.selectedStudents = [];
    this.filterForm.reset();
    this.filterForm.patchValue({ class: null, batch: null });
    this.cascadedService.reset();
    this.classes = [];
    this.batches = [];
    this.isFilterApplied = false;
    this.currentPage = null;
    this.paginationData = {};
    this.emitData();
  }

  saveData() {
    if (this.selectedStudents.length == 0) {
      this.toasterService.setToaster('error', 'Error', 'Please select at least one student');
      return
    }

    this.isreqSending = true
    let data: any = {};
    data.student_ids = this.selectedStudents.map((student: any) => student.id);
    this.commonApiService.addStudentToEntities(this.type, this.categoryData.id, data).
      pipe(finalize(() => { this.isreqSending = false; }))
      .subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message || 'Class updated successfully');
            this.closeModal('close');
            
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      })
  }

  emitData() {
    this.closeModalemmit.emit(null);
  }

  applyFilters() {
    if (this.isSelectedView) {
      this.studentList = [...this.selectedStudents];
      return;
    }
    this.currentPage = null;
    // Ensure group students are loaded before applying filters
    this.getstudentsingroup().then(() => {
      this.getStudents(this.filterForm.value);
      this.isFilterApplied = true;
    });
  }

  resetSearchForm() {
    this.filterForm.reset();
    this.cascadedService.reset();
    this.filterForm.patchValue({ class: null, batch: null });
    this.classes = [];
    this.batches = [];
    this.isFilterApplied = false;
    this.currentPage = null;
    if (!this.isSelectedView) {
      this.getStudents();
    }
  }

  pageChange(page: number) {
    this.currentPage = page;
    if (!this.isSelectedView) {
      this.getStudents(this.filterForm.value);
    }
  }

  setFields(event: Event, type: 'department' | 'class') {
    const target = event.target as HTMLSelectElement;
    const value = target?.value;

    if (!value || value === 'null') {
      if (type === 'department') {
        this.cascadedService.reset();
        this.filterForm.patchValue({ class: null, batch: null });
        this.filterForm.get('class')?.disable();
        this.filterForm.get('batch')?.disable();
        this.classes = [];
        this.batches = [];
      } else if (type === 'class') {
        this.cascadedService.reset();
        this.filterForm.patchValue({ batch: null });
        this.filterForm.get('batch')?.disable();
        this.batches = [];
      }
      this.currentPage = null;
      return;
    }

    const numericValue = +value;

    if (type === 'department') {
      this.cascadedService.setDepartment(value);
      const matched = this.departments.find(d => d.id === numericValue);
      this.classes = matched?.classes || [];
      this.batches = [];

      this.filterForm.patchValue({ class: null, batch: null });
      this.filterForm.get('class')?.enable();
      this.filterForm.get('batch')?.disable();
      this.currentPage = null;
    }

    if (type === 'class') {
      this.cascadedService.setClass(value);
      const matched = this.classes.find(c => c.id === numericValue);
      this.batches = matched?.batches || [];

      this.filterForm.patchValue({ batch: null });
      this.filterForm.get('batch')?.enable();
      this.currentPage = null;
    }
  }


}
